import React from "react";
import Tooltip from "@mui/material/Tooltip";

const Bar = ({ color, completed, tooltip }) => {
	const wrapperStyles = {
		height: "11px",
		flexDirection: "row",
		display: "flex",
		justifyContent: "flex-start",
		alignItems: "center",
	};

	const fillerStyles = {
		height: "100%",
		minWidth: "10px",
		width: `${completed}%`,
		backgroundColor: color,
	};

	return (
		<div key={completed} style={wrapperStyles}>
			<Tooltip title={tooltip}>
				<div style={fillerStyles}></div>
			</Tooltip>
		</div>
	);
};

export default Bar;
